module.exports = __webpack_public_path__ + "media/application/images/2018/icon-peoples-choice-7c800ea31e6c3c8165a016e298534a17.svg";